import React from 'react';

import './cardItem.style.css';

const cardItem = ({ label, value, style = 'primary' }) => {
    const secondaryStyle = style === 'secondary' ? 'CardItemUnguaranteed' : '';
    return (
        <div className="CardItem">
            <div className={`CardItemLabel ${secondaryStyle}`}>{label}</div>
            <span className={`CardItemValue ${secondaryStyle}`}>{value}</span>
        </div>
    );
};

export default cardItem;
